module.exports = __webpack_public_path__ + "img/savings-account.5037d77a.svg";